import React from "react";

type Key = {
  char: string;
  svg?: React.ReactElement;
  gap?: number;
  span?: number;
};

export const qwertyLayout: Key[] = [
  {
    char: "Q",
  },
  {
    char: "W",
  },
  {
    char: "E",
  },
  {
    char: "R",
  },
  {
    char: "T",
  },
  {
    char: "Y",
  },
  {
    char: "U",
  },
  {
    char: "I",
  },
  {
    char: "O",
  },
  {
    char: "P",
  },
  {
    char: "←",
    svg: (
      <svg
        width="31"
        height="21"
        viewBox="0 0 31 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M16 4L23 16" stroke="white" strokeWidth="2" />
        <path d="M15.8682 16.43L22.249 4" stroke="white" strokeWidth="2" />
        <path d="M11 1H30V20H11L2 10.5L11 1Z" stroke="white" strokeWidth="2" />
      </svg>
    ),
  },
  {
    char: "A",
    gap: -10,
  },
  {
    char: "S",
  },
  {
    char: "D",
  },
  {
    char: "F",
  },
  {
    char: "G",
  },
  {
    char: "H",
  },
  {
    char: "J",
  },
  {
    char: "K",
  },
  {
    char: "L",
  },
  {
    char: "Z",
    gap: -9,
  },
  {
    char: "X",
  },
  {
    char: "C",
  },
  {
    char: "V",
  },
  {
    char: "B",
  },
  {
    char: "N",
  },
  {
    char: "M",
  },
  {
    char: " ",
    svg: (
      <svg
        width="51"
        height="9"
        viewBox="0 0 51 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M1 0.5V7.5H25.25H49.5V0.5" stroke="white" strokeWidth="2" />
      </svg>
    ),
    gap: -4,
    span: 5,
  },
];
